import gql from 'graphql-tag';

const fragments = {
    GlobalMessages: gql`
        fragment GlobalBannerGlobalMessages on GlobalMessages {
            banner {
                body {
                    text {
                        value
                    }
                    link {
                        href
                        text {
                            value
                        }
                    }
                }
                id
                severity
                title {
                    value
                }
            }
        }
    `,
};

export default fragments;
